<!-- 
 * @description: 忘记密码模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-21 17:13:09
!-->
<template>
  <div
    class="forgot"
    :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mforgot' : 'forgot'"
  >
    <div
      class="back"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mback' : 'back'"
      @click="childForgot"
    ></div>
    <div class="title">{{ $t("message.forget_password") }}</div>
    <!-- 填写邮箱 -->
    <div class="addEmail" v-if="isShow == 1">
      <!-- input -->
      <div class="inputBox">
        <div class="input-style">
          <input
            type="text"
            :placeholder="$t('message.input_email_address')"
            class="user"
            v-model.trim="verifyEmail"
            @click="focusEnd('forgotVerifyEmail')"
            id="forgotVerifyEmail"
          />
        </div>
      </div>
      <!-- 提示文案 -->
      <div class="tips" v-if="tispText">{{ tips }}</div>
      <!-- 提交按钮 -->
      <div
        class="sendBtn"
        :class="verifyEmail ? 'active' : ''"
        @click="verifyBindEmail"
      >
        {{ $t("message.next_step") }}
      </div>
    </div>
    <!-- 绑定账号 -->
    <div class="bindEmail" v-if="isShow == 2">
      <!-- 获取到绑定账号 -->
      <div class="bindTips">
        {{ $t("message.bound_email") }}<span>{{ bingEmailInfo }}</span
        >{{ $t("message.input_reset_password") }}
      </div>
      <!-- input -->
      <div class="inputBox">
        <div class="input-style">
          <input
            type="text"
            :placeholder="$t('message.enter_code')"
            class="user"
            v-model.trim="code"
            @click="focusEnd('forgotCode')"
            id="forgotCode"
          />
          <div v-show="show" @click="sendEmailCode" class="sendCode">
            {{ $t("message.get_code") }}
          </div>
          <div v-show="!show" class="sendCode">
            {{ count }}{{ $t("message.get_code_seconds") }}
          </div>
        </div>
      </div>
      <!-- 提示文案 -->
      <div class="tips" v-if="tispText1">{{ tips1 }}</div>
      <!-- 下一步按钮 -->
      <div class="sendBtn" :class="code ? 'active' : ''" @click="btnCode">
        {{ $t("message.next_step") }}
      </div>
    </div>

    <!-- 设置新密码 -->
    <div class="setNewPass" v-if="isShow == 3">
      <!-- input -->
      <div class="inputBox">
        <div class="input-style">
          <input
            type="password"
            :placeholder="$t('message.input_password')"
            class="pass"
            v-model.trim="password"
            @click="focusEnd('forgotPassword')"
            id="forgotPassword"
          />
        </div>
        <div class="input-style">
          <input
            type="password"
            :placeholder="$t('message.input_password_again')"
            class="pass"
            v-model.trim="confirmPassword"
            @click="focusEnd('forgotConfirmPassword')"
            id="forgotConfirmPassword"
          />
        </div>
      </div>
      <!-- 提示文案 -->
      <div class="tips" v-if="tispText2">{{ tips2 }}</div>
      <!-- 下一步按钮 -->
      <div
        class="sendBtn"
        :class="password && confirmPassword ? 'active' : ''"
        @click="changePwdEmail2"
      >
        {{ $t("message.confirm") }}
      </div>
    </div>
  </div>
</template>

<script>
import { RSSign } from "../../utils/sign.js";
import isEmail from "validator/lib/isEmail";
export default {
  name: "RastarForgot",
  props: ["appId", "pId", "mdId", "ukey", "system", "getCodeShow"],
  data() {
    return {
      verifyEmail: "",
      code: "",
      password: "",
      // 确认密码
      confirmPassword: "",
      isShow: 1,
      // 绑定邮箱
      bindEmail: "",
      tips: "",
      tispText: false,
      tips1: "",
      tispText1: false,
      tips2: "",
      tispText2: false,
      show: true,
      count: "",
      timer: null,
      bingEmailInfo: "",
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
    };
  },
  methods: {
    sendCodeShow() {
      this.getCodeShow(false);
    },
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    childForgot() {
      if (this.isShow == 3) {
        this.isShow = 2;
      } else if (this.isShow == 2) {
        this.isShow = 1;
      } else if (this.isShow == 1) {
        this.$emit("forgot", false);
      }
    },
    /*
     *@description: 校验邮箱或者帳號是否绑定
     *@author: 薛微微
     *@date: 2023-06-21 16:58:28
     */
    verifyBindEmail() {
      if (this.verifyEmail !== "") {
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              let uinfoData = {
                uname: this.verifyEmail,
              };
              let data = {
                ts: new Date().getTime(),
                cch_id: this.pId,
                app_id: this.appId,
                token: res.data,
                sys_language: this.$Storage.localStorageGet("lang"),
                nonce: this.$Base.nonce(12),
                sdk_ver: this.$Base.sdkVer(),
                version: this.$Base.getVersion(),
              };
              data.uinfo = this.$Ciphertext.AESkey(uinfoData);
              data.sign = RSSign(data, data.app_id);
              this.$SyModel
                .verifyBindEmail(this.apiUrl.user.check_email, data)
                .then((res) => {
                  // 200 已绑定，201 未绑定
                  if (res.code == 200) {
                    this.isShow = 2;
                    this.bingEmailInfo = res.data.email;
                  } else {
                    this.tispText = true;
                    this.tips = res.msg.replace(/\[.*?\]/g, "");
                    // this.$toast(res.msg);
                  }
                });
            }
          });
      } else {
        this.$toast(this.$t("message.input_bind_email"));
        return;
      }
    },
    /*
     *@description: 发送邮箱邮箱验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:00:31
     */
    sendEmailCode() {
      if (!isEmail(this.bingEmailInfo)) {
        this.$toast(this.$t("message.incorrect_email"));
        return;
      }
      if (this.bingEmailInfo !== "") {
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              let uinfoData = {
                email: this.bingEmailInfo,
                type: "forget_pwd",
              };
              let data = {
                ts: new Date().getTime(),
                cch_id: this.pId,
                app_id: this.appId,
                token: res.data,
                sys_language: this.$Storage.localStorageGet("lang"),
                time_zone: this.$Base.timeZone(),
                nonce: this.$Base.nonce(12),
                sdk_ver: this.$Base.sdkVer(),
                version: this.$Base.getVersion(),
              };
              data.uinfo = this.$Ciphertext.AESkey(uinfoData);
              data.sign = RSSign(data, data.app_id);
              this.$SyModel
                .sendEmailCode(this.apiUrl.user.send_email, data)
                .then((res) => {
                  if (res.code == 200) {
                    this.tispText1 = true;
                    this.tips1 = res.msg.replace(/\[.*?\]/g, "");
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                      this.count = TIME_COUNT;
                      this.show = false;
                      this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                          this.count--;
                        } else {
                          this.show = true;
                          clearInterval(this.timer);
                          this.timer = null;
                        }
                      }, 1000);
                    }
                  } else if (res.code == 2503) {
                    this.tispText1 = true;
                    this.tips1 = res.msg.replace(/\[.*?\]/g, "");
                  }
                });
            }
          });
      } else {
        this.$toast(this.$t("message.input_email_address"));
        return;
      }
    },
    /*
     *@description: 校验邮箱验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:00:59
     */
    btnCode() {
      if (this.code !== "") {
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              this.validEmailCode(res.data);
            }
          });
      }
    },
    validEmailCode(token) {
      if (this.code !== "") {
        let uinfoData = {
          email: this.bingEmailInfo,
          type: "forget_pwd",
          vcode: this.code,
        };
        let data = {
          ts: new Date().getTime(),
          cch_id: this.pId,
          app_id: this.appId,
          token: token,
          sys_language: this.$Storage.localStorageGet("lang"),
          time_zone: this.$Base.timeZone(),
          nonce: this.$Base.nonce(12),
          sdk_ver: this.$Base.sdkVer(),
          version: this.$Base.getVersion(),
        };
        data.uinfo = this.$Ciphertext.AESkey(uinfoData);
        data.sign = RSSign(data, data.app_id);
        this.$SyModel
          .validEmailCode(this.apiUrl.user.valid_email, data)
          .then((res) => {
            if (res.code == 200) {
              this.isShow = 3;
            } else {
              this.tispText1 = true;
              this.tips1 = res.msg.replace(/\[.*?\]/g, "");
            }
          });
      }
    },
    /*
     *@description: 修改密码
     *@author: 薛微微
     *@date: 2023-06-21 17:01:11
     */
    changePwdEmail(token) {
      let uinfoData = {
        pwd: this.password,
        bind_v: this.bingEmailInfo,
        bind_type: 4,
      };
      let data = {
        ts: new Date().getTime(),
        cch_id: this.pId,
        app_id: this.appId,
        token: token,
        sys_language: this.$Storage.localStorageGet("lang"),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .changePwdEmail(this.apiUrl.user.find_pwd_email, data)
        .then((res) => {
          if (res.code == 200) {
            this.isShow = 0;
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            this.$emit("forgot", false);
          } else {
            this.tispText2 = true;
            this.tips2 = res.msg.replace(/\[.*?\]/g, "");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*
     *@description: 请求修改密码
     *@author: 薛微微
     *@date: 2023-06-21 17:01:35
     */
    changePwdEmail2() {
      let _this = this;
      if (_this.password !== "" && _this.confirmPassword !== "") {
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        if (reg.test(_this.password) || reg.test(_this.confirmPassword)) {
          _this.tispText2 = true;
          _this.tips2 = _this.$t("message.emailTips1");
          return;
        }
        var pPattern = /^.*(?=.{6,}).*$/;
        if (!pPattern.test(_this.password)) {
          _this.tispText2 = true;
          _this.tips2 = _this.$t("message.emailTips2");
          return;
        }
        if (_this.password !== _this.confirmPassword) {
          _this.tispText2 = true;
          _this.tips2 = _this.$t("message.emailTips3");
          // _this.$toast(_this.$t("message.emailTips3"));
          return;
        }
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              _this.changePwdEmail(res.data);
            }
          });
      }
    },
  },
  created() {
    this.sendCodeShow();
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
